// extracted by mini-css-extract-plugin
export default {"wrapper":"SwitchTab_wrapper__0A9jT","tab-wrapper":"SwitchTab_tab-wrapper__Sb3Ck","more-button":"SwitchTab_more-button__rIKTb","pill":"SwitchTab_pill__ZZ4rm"};